const translations: Record<string, string> = {
  action_save: 'Zapisz',
  action_saving: 'Zapisywanie...',
  // Greeting
  greeting_morning: 'Dzień dobry',
  greeting_day: 'Dzień dobry',
  greeting_evening: 'Dobry wieczór',

  // Nav sections
  nav_cabinet: 'Panel',
  nav_operations: 'Operacje',
  nav_system: 'System',
  nav_platform_admin: 'Admin Platformy',
  nav_administration: 'Administracja',

  // Nav items
  nav_dashboard: 'Pulpit',
  nav_owner_dashboard: 'Dashboard właściciela',
  nav_platform_dashboard: 'Dashboard',
  nav_platform_tenants: 'Przegląd tenantów',
  nav_platform_users: 'Przegląd użytkowników',
  nav_platform_counterparties: 'Przegląd kontrahentów',
  nav_platform_assets: 'Przegląd aktywów',
  nav_onboarding: 'Onboarding',
  nav_counterparties: 'Kontrahenci',
  nav_assets: 'Aktywa',
  nav_contracts: 'Kontrakty',
  nav_documents: 'Dokumenty',
  nav_forecast: 'Prognoza',
  nav_bess: 'BESS',
  nav_comdisp: 'Dyspozytornia handlowa',
  nav_monitor: 'Monitor',
  nav_settings: 'Ustawienia',
  nav_tenants: 'Tenants',
  nav_tenant_users: 'Użytkownicy tenantów',
  nav_roles: 'Role',

  // Topbar
  topbar_search: 'Szukaj...',
  topbar_notifications: 'Powiadomienia',
  topbar_add_station: 'Dodaj stację',
  topbar_profile: 'Profil',
  topbar_settings: 'Ustawienia',
  topbar_company: 'Firma',
  topbar_team: 'Zespół',
  topbar_logout: 'Wyloguj się',

  // Home page
  home_breadcrumb_home: 'Strona główna',
  home_breadcrumb_dashboard: 'Pulpit',
  home_export: 'Eksport',
  home_submit_mms: 'Wyślij MMS',
  home_hourly_chart: 'Godzinowy wykres produkcji',
  home_vs_yesterday: '↑ 12% vs wczoraj',
  home_col_hour: 'Godzina',
  home_col_forecast: 'Prognoza',
  home_col_fact: 'Fakt',
  home_col_deviation: 'Odchylenie',
  home_col_price: 'Cena DAM',
  home_col_revenue: 'Przychód',

  // Notifications
  notif_inverter_alarm: 'Inwerter #3 — alarm',
  notif_mms_confirmed: 'Raport MMS potwierdzony',
  notif_market_digest: 'Nowy digest rynkowy',
  notif_2h: '2 godz.',
  notif_yesterday: 'wczoraj',

  // User menu
  user_guest: 'Gość',

  // Assets page
  assets_title: 'Aktywa',
  assets_subtitle: 'Zarządzanie aktywami energetycznymi',
  assets_search: 'Szukaj po nazwie lub kodzie EIC...',
  assets_all_types: 'Wszystkie typy',
  assets_loading: 'Ładowanie aktywów...',
  assets_not_found: 'Nie znaleziono aktywów',
  assets_not_found_hint: 'Aktywa są tworzone z profilu kontrahenta',
  assets_filter_hint: 'Spróbuj zmienić filtry',
  assets_col_asset: 'Aktywo',
  assets_col_eic: 'Kod EIC',
  assets_col_type: 'Typ',
  assets_col_capacity: 'Moc',
  assets_col_region: 'Region',
  assets_col_status: 'Status',
  assets_col_counterparty: 'Kontrahent',

  // Contracts page
  contracts_title: 'Kontrakty',
  contracts_subtitle: 'Zarządzanie umowami PPA, dostawczymi i serwisowymi',
  contracts_search: 'Szukaj po numerze lub kontrahencie...',
  contracts_loading: 'Ładowanie kontraktów...',
  contracts_not_found: 'Nie znaleziono kontraktów',
  contracts_not_found_hint: 'Kontrakty są tworzone z profilu aktywa',
  contracts_filter_hint: 'Spróbuj inne zapytanie',
  contracts_col_number: 'Numer',
  contracts_col_type: 'Typ',
  contracts_col_counterparty: 'Kontrahent',
  contracts_col_asset: 'Aktywo',
  contracts_col_period: 'Okres',
  contracts_col_status: 'Status',

  // Documents page
  documents_title: 'Dokumenty',
  documents_subtitle: 'Zarządzanie metadanymi dokumentów i weryfikacja',
  documents_search: 'Szukaj po nazwie pliku lub kontrahencie...',
  documents_loading: 'Ładowanie dokumentów...',
  documents_not_found: 'Nie znaleziono dokumentów',
  documents_not_found_hint: 'Dokumenty są dodawane z profilów aktywów lub kontrahentów',
  documents_filter_hint: 'Spróbuj inne zapytanie',
  documents_col_file: 'Plik',
  documents_col_type: 'Typ',
  documents_col_counterparty: 'Kontrahent',
  documents_col_asset_contract: 'Aktywo / Kontrakt',
  documents_col_status: 'Status',
  documents_col_uploaded: 'Przesłano',
  documents_col_by: 'Przez',

  // Forecast page
  forecast_title: 'Prognoza',
  forecast_subtitle: 'Prognozowanie generacji · Model ML v0.2.2',
  forecast_export: 'Eksport XLSX',
  forecast_weather_title: 'Pogoda / Bołhrad',
  forecast_weather_partly_cloudy: 'Mało chmurnie',
  forecast_weather_insolation: 'Nasłonecznienie',
  forecast_weather_clouds: 'Zachmurzenie',
  forecast_weather_wind: 'Wiatr',
  forecast_weather_humidity: 'Wilgotność',
  forecast_model_title: 'Model ML',
  forecast_model_version: 'Wersja',
  forecast_model_updated: 'Zaktualizowano',
  forecast_model_horizon: 'Horyzont',
  forecast_model_training: 'Trening',
  forecast_model_mape: 'MAPE (7 dni)',
  forecast_accuracy: 'Dokładność prognozy',
  forecast_accuracy_period: 'za ostatnie 30 dni',

  // Counterparties page
  cp_title: 'Kontrahenci',
  cp_subtitle: 'Zarządzaj kontrahentami i partnerami biznesowymi',
  cp_new: 'Nowy kontrahent',
  cp_search: 'Szukaj po nazwie lub EDRPOU...',
  cp_loading: 'Ładowanie kontrahentów...',
  cp_not_found: 'Nie znaleziono kontrahentów',
  cp_not_found_hint: 'Utwórz pierwszego kontrahenta, aby zacząć',
  cp_filter_hint: 'Spróbuj innego zapytania',
  cp_start_onboarding: 'Rozpocznij onboarding',
  cp_col_name: 'Nazwa',
  cp_col_edrpou: 'EDRPOU',
  cp_col_country: 'Kraj',
  cp_col_status: 'Status',
  cp_col_onboarding: 'Onboarding',
  cp_col_assets: 'Aktywa',
  cp_col_created: 'Utworzono',

  // Onboarding page
  ob_title: 'Onboarding kontrahenta',
  ob_subtitle: 'Wypełnij 5-krokowy formularz, aby zarejestrować organizację w systemie Helios.',
  ob_step_company: 'Firma',
  ob_step_legal: 'Prawne',
  ob_step_contact: 'Kontakt',
  ob_step_bank: 'Bank',
  ob_step_roles: 'Role',
  ob_back: 'Wstecz',
  ob_next: 'Dalej',
  ob_submit: 'Wyślij',
  ob_submitting: 'Wysyłanie...',
  ob_success_title: 'Onboarding wysłany',
  ob_success_text: 'Kontrahent został utworzony i oczekuje na weryfikację. ID:',
  ob_complete: 'Zakończ onboarding',
  ob_completing: 'Kończenie...',
  ob_go_to_profile: 'Przejdź do profilu',
  ob_fill_required: 'Wypełnij wszystkie wymagane pola',
  ob_select_role: 'Wybierz co najmniej jedną rolę',

  // Onboarding Step 1 — Company Identity
  ob_s1_title: 'Identyfikacja firmy',
  ob_s1_subtitle: 'Wprowadź podstawowe dane identyfikacyjne swojej firmy.',
  ob_s1_name: 'Nazwa firmy',
  ob_s1_name_ph: 'np. Helios Energy Sp. z o.o.',
  ob_s1_shortName: 'Nazwa skrócona',
  ob_s1_shortName_ph: 'np. Helios',
  ob_s1_edrpou: 'Kod EDRPOU',
  ob_s1_edrpou_ph: '8-cyfrowy kod',
  ob_s1_taxId: 'NIP',
  ob_s1_taxId_ph: 'Numer identyfikacji podatkowej',
  ob_s1_country: 'Kraj',
  ob_s1_country_ph: 'np. Ukraina',

  // Onboarding Step 2 — Legal Profile
  ob_s2_title: 'Profil prawny',
  ob_s2_subtitle: 'Podaj dane prawne i rejestracyjne swojej organizacji.',
  ob_s2_fullLegalName: 'Pełna nazwa prawna',
  ob_s2_fullLegalName_ph: 'Pełna nazwa podmiotu zgodnie z rejestrem',
  ob_s2_legalAddress: 'Adres prawny',
  ob_s2_legalAddress_ph: 'Zarejestrowany adres prawny',
  ob_s2_actualAddress: 'Adres faktyczny',
  ob_s2_actualAddress_ph: 'Fizyczny adres biura',
  ob_s2_registrationCountry: 'Kraj rejestracji',
  ob_s2_registrationCountry_ph: 'np. Ukraina',
  ob_s2_vatStatus: 'Status VAT',
  ob_s2_vatStatus_ph: 'Wybierz status VAT',
  ob_s2_vat_registered: 'Zarejestrowany',
  ob_s2_vat_not_registered: 'Niezarejestrowany',
  ob_s2_vat_exempt: 'Zwolniony',
  ob_s2_vatNumber: 'Numer VAT',
  ob_s2_vatNumber_ph: 'Numer identyfikacji VAT',
  ob_s2_directorName: 'Imię i nazwisko dyrektora',
  ob_s2_directorName_ph: 'Pełne imię i nazwisko dyrektora generalnego',
  ob_s2_authorizedPerson: 'Osoba upoważniona',
  ob_s2_authorizedPerson_ph: 'Imię i nazwisko osoby upoważnionej do podpisu',
  ob_s2_basisOfAuthority: 'Podstawa upoważnienia',
  ob_s2_basisOfAuthority_ph: 'Statut / Pełnomocnictwo / Zarządzenie',

  // Onboarding Step 3 — Primary Contact
  ob_s3_title: 'Główny kontakt',
  ob_s3_subtitle: 'Wskaż główną osobę kontaktową w swojej organizacji.',
  ob_s3_fullName: 'Imię i nazwisko',
  ob_s3_fullName_ph: 'np. Jan Kowalski',
  ob_s3_position: 'Stanowisko',
  ob_s3_position_ph: 'np. Dyrektor operacyjny',
  ob_s3_email: 'Email',
  ob_s3_email_ph: 'contact@company.com',
  ob_s3_phone: 'Telefon',
  ob_s3_phone_ph: '+48 500 123 456',
  ob_s3_contactType: 'Typ kontaktu',
  ob_s3_contactType_ph: 'Wybierz typ kontaktu',
  ob_s3_ct_technical: 'Techniczny',
  ob_s3_ct_legal: 'Prawny',
  ob_s3_ct_financial: 'Finansowy',
  ob_s3_ct_dispatch: 'Dyspozytorski',
  ob_s3_ct_commercial: 'Handlowy',
  ob_s3_ct_general: 'Ogólny',
  ob_s3_isPrimary: 'Ustaw jako główny kontakt',

  // Onboarding Step 4 — Bank Account
  ob_s4_title: 'Konto bankowe',
  ob_s4_subtitle: 'Podaj podstawowe dane bankowe do rozliczeń.',
  ob_s4_bankName: 'Nazwa banku',
  ob_s4_bankName_ph: 'np. PKO Bank Polski',
  ob_s4_iban: 'IBAN',
  ob_s4_iban_ph: 'PL61109010140000071219812874',
  ob_s4_currency: 'Waluta',
  ob_s4_currency_ph: 'PLN / EUR / USD',
  ob_s4_mfo: 'MFO / SWIFT',
  ob_s4_mfo_ph: 'Kod MFO lub SWIFT banku',
  ob_s4_accountHolder: 'Właściciel konta',
  ob_s4_accountHolder_ph: 'Nazwa prawna właściciela konta',
  ob_s4_isPrimary: 'Ustaw jako główne konto bankowe',

  // Onboarding Step 5 — Roles
  ob_s5_title: 'Role biznesowe',
  ob_s5_subtitle: 'Wybierz wszystkie role odpowiadające Twojej organizacji. Możesz wybrać kilka.',
  ob_s5_selected: 'Wybrane role',
  ob_s5_none: 'Nie wybrano ról',
  ob_s5_role_generator_owner: 'Właściciel generacji',
  ob_s5_role_generator_owner_desc: 'Posiada i eksploatuje aktywa energii odnawialnej',
  ob_s5_role_supplier: 'Dostawca',
  ob_s5_role_supplier_desc: 'Dostarcza energię elektryczną odbiorcom końcowym',
  ob_s5_role_trader: 'Trader',
  ob_s5_role_trader_desc: 'Kupuje i sprzedaje energię na rynkach hurtowych',
  ob_s5_role_consumer: 'Odbiorca',
  ob_s5_role_consumer_desc: 'Nabywa energię elektryczną na własne potrzeby',
  ob_s5_role_balancing_group_member: 'Uczestnik grupy bilansującej',
  ob_s5_role_balancing_group_member_desc: 'Uczestniczy w grupie bilansującej',
  ob_s5_role_bess_operator: 'Operator BESS',
  ob_s5_role_bess_operator_desc: 'Eksploatuje systemy magazynowania energii',
  ob_s5_role_service_provider: 'Dostawca usług',
  ob_s5_role_service_provider_desc: 'Świadczy usługi techniczne lub handlowe',

  // Login page
  login_welcome: 'Witamy',
  login_subtitle: 'Zaloguj się do swojego obszaru roboczego',
  login_label_login: 'Login',
  login_label_password: 'Hasło',
  login_btn: 'Zaloguj się →',
  login_checking: 'Sprawdzanie...',
  login_error_empty: 'Wprowadź login i hasło',
  login_error_wrong: 'Nieprawidłowy login lub hasło',
  login_error_rate: 'Zbyt wiele prób logowania. Spróbuj za {{sec}} s',
  login_error_unavailable: 'Serwer chwilowo niedostępny — spróbuj ponownie',
  login_forgot: 'Zapomniałeś hasła?',
  login_restore: 'Przywróć',
  login_new_company: 'Nowa firma?',
  login_demo: 'Zamów demo',

  // BESS page
  bess_title: 'Magazynowanie energii',
  bess_subtitle: 'Telemetria systemu magazynowania energii',
  bess_export: 'Eksport',
  bess_soc: 'Poziom naładowania (SOC)',
  bess_soh: 'Stan zdrowia (SOH)',
  bess_status: 'Status',
  bess_live: 'Na żywo',
  bess_stale: 'Nieaktualne',
  bess_discharge: 'Rozładowanie / Wyjście Aktywne',
  bess_charge: 'Dostępne do ładowania',
  bess_power: 'Moc aktywna',
  bess_power_flow: 'Kierunek mocy',
  bess_voltage: 'Napięcie baterii',
  bess_current: 'Prąd baterii',
  bess_bms: 'Status BMS',
  bess_pcs: 'Status PCS',
  bess_config: 'Konfiguracja',
  bess_nominal_capacity: 'Pojemność nominalna',
  bess_nominal_power: 'Moc nominalna',
  bess_visible_capacity: 'Widoczna pojemność użytkowa',
  bess_pcs_avail: 'Dostępność PCS',
  bess_updated: 'Zaktualizowano',
  bess_refresh: 'Odśwież',
  bess_no_telemetry: 'Telemetria BESS niedostępna',
  bess_retry: 'Spróbuj ponownie',
  bess_section_gauges: 'Wskaźniki pojemności',
  bess_section_battery: 'Stan baterii',
  bess_section_power: 'Moc i konfiguracja',
  bess_section_status: 'Status systemu',

  // UEEX market data
  nav_market: 'Rynek',
  nav_market_ueex: 'UEEX',
  nav_info_analytics: 'Analityka',
  nav_owner_home: 'Pulpit',
  nav_disp_home: 'Pulpit',
  nav_sec_dispatch: 'Dyspozytornia',
  nav_disp_fact: 'Fakt',
  nav_disp_scada: 'SCADA',
  nav_sec_finance: 'Finanse',
  nav_fin_cashflow: 'Cash Flow',
  nav_fin_pl: 'P&L',
  nav_fin_reports: 'Raporty',
  nav_gen: 'Generacja',
  nav_dispatch2: 'Dyspozycja',
  nav_incidents: 'Incydenty',
  nav_reports: 'Raportowanie',
  nav_sec_market: 'Rynek',
  nav_market_prices: 'Ceny',
  nav_gen_deviation: 'Odchylenie',
  nav_bess_state: 'Stan bieżący',
  nav_fin_income: 'Przychód',
  nav_fin_charges: 'Naliczenia',
  nav_fin_bess_arb: 'Arbitraż BESS',
  nav_an_news: 'Wiadomości',
  nav_notifications: 'Powiadomienia',
  nav_trade_schedule: 'Harmonogram handlu',
  nav_mms: 'Przekazanie do MMS',
  nav_disp_commands: 'Polecenia dyspozytora',
  nav_scada_monitoring: 'Monitoring urządzeń',
  nav_scada_telemetry: 'Telemetria',
  nav_scada_control: 'Sterowanie ręczne',
  nav_scada_events: 'Zdarzenia',
  nav_bess_charge: 'Ładowanie',
  nav_bess_discharge: 'Rozładowanie',
  nav_bess_arbitrage: 'Arbitraż',
  nav_assets_list: 'Lista elektrowni',
  nav_inc_faults: 'Awarie',
  nav_inc_limits: 'Ograniczenia',
  nav_inc_alarms: 'Alarmy',
  nav_rep_regulatory: 'Regulacyjne',
  nav_rep_management: 'Zarządcze',
  nav_rep_dispatch: 'Dyspozytorskie',
  nav_doc_contracts: 'Umowy',
  nav_doc_acts: 'Akty',
  nav_doc_correspondence: 'Korespondencja',
  nav_set_users: 'Użytkownicy',
  nav_set_roles: 'Role',
  nav_set_integrations: 'Integracje',
  nav_sec_analytics: 'Analityka',
  nav_an_market: 'Rynek',
  ueex_page_title: 'Ukraińska Giełda Energii',
  ueex_page_subtitle: 'Ceny aukcyjne energii + Gwarancje pochodzenia (Solar GO)',
  ueex_page_window: 'Okres',
  ueex_page_days: 'dni',
  ueex_tab_electricity: 'Energia',
  ueex_tab_solar_go: 'Solar GO',
  ueex_tab_auctions: 'Aukcje',
  ueex_kpi_base_wavg: 'BASE cena średnioważona',
  ueex_kpi_block_wavg: 'Block cena średnioważona',
  ueex_kpi_premium: 'BASE premia',
  ueex_chart_price_title: 'Dynamika cen dziennych',
  ueex_chart_volume_title: 'Dzienne wolumeny',
  ueex_top_sellers_base: 'Top sprzedawcy BASE',
  ueex_no_data: 'Brak danych',
  ueex_seller: 'Sprzedawca',
  ueex_deals: 'Transakcje',
  ueex_wavg_price: 'Średnia cena',
  ueex_revenue: 'Przychód',
  ueex_solar_banner_title: 'Solar GO — rynek tylko po stronie podaży',
  ueex_solar_banner_text: 'Przez 90 dni sprzedano 0 MWh certyfikatów. Ceny ofertowe to baseline dla kontraktów B2B.',
  ueex_solar_avg_ask: 'Średnia cena ofertowa',
  ueex_solar_sell_positions: 'Pozycji sprzedaży',
  ueex_solar_closed_deals: 'Zamkniętych transakcji',
  ueex_solar_offered_volume: 'Wolumen oferowany',
  ueex_solar_chart_title: 'Solar GO ceny + wolumen',
  ueex_recent_auctions: 'Ostatnie aukcje',
  ueex_auc_num: 'Numer',
  ueex_auc_date: 'Data',
  ueex_auc_type: 'Typ',
  ueex_auc_state: 'Stan',
  ueex_auc_positions: 'Pozycje',
  ueex_auc_closed: 'Zamknięto',
  ueex_widget_title: 'UEEX — aktualne ceny',
  ueex_widget_view_all: 'Szczegóły',
  ueex_widget_loading: 'Ładowanie...',
  ueex_widget_base_label: 'BASE (24/7)',
  ueex_widget_block_label: 'Pozycja blokowa',
  ueex_widget_solar_label: 'Solar GO (ask)',
  ueex_widget_source: 'Źródło: epbets.ueex.com.ua',
  ueex_widget_subtitle: 'Dynamika cen w ostatnich dniach',
  ueex_widget_no_recent_data: 'Brak zamkniętych transakcji w ostatnim tygodniu',
  ueex_sections_title: 'Sekcje',
  ueex_section_electric_power: 'Energia',
  ueex_section_bilateral_contracts: 'Kontrakty dwustronne',
  ueex_section_solar_go: 'Solar GO',
  ueex_section_renewable_go: 'OZE GP porównanie',
  ueex_section_auctions: 'Wszystkie aukcje',
  ueex_external_link: 'Oficjalna strona UEEX',
  ueex_kpi_peak_wavg: 'PEAK średnia cena',
  ueex_chart_auctions_title: 'Wyniki aukcji sprzedaży energii',
  ueex_chart_auctions_subtitle: 'Średnia ważona cena dziennych transakcji, UAH/MWh bez VAT',
  ueex_source_note: 'Źródło',
  ueex_bilateral_title: 'Wyniki rynku kontraktów dwustronnych',
  ueex_bilateral_subtitle: 'Pozycje energetyczne',
  ueex_records: 'rekordów',
  ueex_renewable_title: 'Gwarancje pochodzenia OZE',
  ueex_renewable_subtitle: 'Porównanie Solar/Wind/Hydro/Bio',
  ueex_renewable_placeholder: 'Wykres będzie dodany w następnej iteracji',
  ueex_renewable_data_source: '(dane już zbierane)',
  ueex_all_auctions_title: 'Wszystkie aukcje',
  ueex_all_types: 'Wszystkie typy',
  ueex_loading: 'Ładowanie...',
  ueex_widget_days_suffix: 'd',
  ueex_widget_deals: 'transakcji',
  ueex_widget_positions: 'pozycji',
  ueex_widget_no_peak: 'Brak handlu PEAK',
  nav_sko: 'SKO',
  sko_page_title: 'System zarządzania ograniczeniami OZE',
  sko_page_subtitle: 'Grafiki PRS i zdarzenia curtailment Ukrenergo',
  sko_sections_title: 'Sekcje',
  sko_section_prs: 'Grafiki PRS',
  sko_section_curtailment: 'Zdarzenia curtailment',
  sko_section_about: 'O SKO',
  sko_external_link: 'Oficjalna strona Ukrenergo',
  sko_prs_banner_title: 'Faza A — Dry-run',
  sko_prs_banner_text: 'XML generowany z prognozy v0.2.2 i zapisywany do DB. Wysyłka SOAP — po podpisaniu umowy.',
  sko_prs_table_title: 'Wygenerowane PRS',
  sko_prs_col_date: 'Data dostawy',
  sko_prs_col_asset: 'Elektrownia',
  sko_prs_col_rev: 'Rew.',
  sko_prs_col_points: 'Punktów',
  sko_prs_col_energy: 'Energia',
  sko_prs_col_status: 'Status',
  sko_prs_preview: 'Podgląd',
  sko_prs_preview_title: 'Podgląd PRS XML',
  sko_close: 'Zamknij',
  sko_loading: 'Ładowanie...',
  sko_no_data: 'Brak danych',
  sko_curt_banner_title: 'Dziennik zdarzeń curtailment',
  sko_curt_banner_text: 'Loguj zdarzenia ograniczenia od dyspozytora OSP.',
  sko_curt_events_title: 'Zdarzenia curtailment',
  sko_curt_add_event: 'Dodaj zdarzenie',
  sko_curt_col_asset: 'Elektrownia',
  sko_curt_col_start: 'Start',
  sko_curt_col_end: 'Koniec',
  sko_curt_col_pct: 'Ograniczenie',
  sko_curt_col_reason: 'Powód',
  sko_curt_col_source: 'Źródło',
  sko_curt_col_dispatcher: 'Dyspozytor',
  sko_curt_active: 'W toku',
  sko_save: 'Zapisz',
  sko_saving: 'Zapisywanie...',
  sko_about_title: 'O Systemie',
  sko_about_p1: 'SKO — system Ukrenergo dla dwustronnej wymiany informacji z OZE.',
  sko_about_p2: 'Producenci wysyłają PRS — 15-min grafiki — przez SOAP.',
  sko_about_p3: 'Faza A — dry-run.',
  sko_about_phase_status: 'Status fazy:',
  sko_inbox_title: 'Skrzynka OSP',
  sko_inbox_subtitle: 'Komendy SKO (top-10)',
  sko_inbox_view_all: 'Wszystkie',
  sko_inbox_loading: 'Ładowanie...',
  sko_inbox_empty: 'Brak komend',
  sko_inbox_no_asset: '(ogólne)',
  sko_inbox_curtailment_to: 'Ograniczenie do',
  sko_inbox_ack_in: 'Potwierdź za',
  sko_inbox_min: 'min',
  sko_inbox_ack: 'Potwierdź',
  sko_inbox_details: 'Szczegóły',
  sko_bell_pending: 'Oczekujące',
  sko_bell_active: 'Aktywne',
  sko_bell_critical: 'Krytyczne',
  sko_bell_none: 'Brak komend',
  sko_section_inbox: 'Skrzynka komend',
  sko_inbox_full_title: 'Wszystkie komendy SKO',
  sko_inbox_filter_all: 'Wszystkie statusy',
  nav_trading: 'Trading',
  nav_trading_overview: 'Przegląd',
  nav_trading_dam: 'RDN',
  nav_trading_idm: 'RDB',
  trading_overview_title: 'Zbiorcza analityka rynku',
  trading_overview_subtitle: 'Spot OREE (DAM + IDM) vs pozagiełda UEEX vs faktyczna generacja naszych SES',
  trading_dam_title: 'Rynek dnia następnego',
  trading_dam_subtitle: 'OREE day-ahead — Zjednoczony System Energetyczny Ukrainy (OES)',
  trading_idm_title: 'Rynek dnia bieżącego',
  trading_idm_subtitle: 'OREE intraday — Zjednoczony System Energetyczny Ukrainy (OES)',
  oree_widget_title: 'Rynek energii OREE',
  oree_widget_subtitle: 'Ceny spot DAM + IDM, źródło: www.oree.com.ua',
  oree_widget_dam_today: 'Cena DAM dziś',
  oree_widget_idm_today: 'Cena IDM dziś',
  oree_widget_dam_7d: 'Średnia DAM 7 dni',
  oree_widget_idm_7d: 'Średnia IDM 7 dni',
  oree_widget_average_label: 'cena ważona',
  oree_widget_days_suffix: 'd',
  oree_dam_label: 'Rynek dnia następnego',
  oree_idm_label: 'Rynek dnia bieżącego',
  oree_volume_label: 'Wolumen obrotu',
  oree_potential_revenue_7d: 'Potencjalny przychód 7 dni',
  oree_potential_revenue_note: 'Ile zarobilibyśmy sprzedając faktyczną generację na DAM zamiast taryfy gwarantowanej',
  oree_tr_zone_label: 'Strefa handlowa',
  oree_daily_price_title: 'Dynamika dziennej ceny ważonej',
  oree_hourly_profile_title: 'Ceny i wolumeny godzinowe w dobie',
  oree_vs_ueex_title: 'Porównanie: spot (OREE) vs pozagiełda (UEEX BASE)',
  oree_vs_generation_title: 'Potencjalny przychód: nasza generacja × cena DAM (ostatnie 7 dni)',
  oree_vs_generation_note: 'Suma wszystkich naszych SES wg faktycznych danych inwerterów (modbus). Przychód = faktyczne MWh × godzinowa cena DAM.',
  common_loading: 'Ładowanie…',
  oree_kpi_price_unit_note: 'UAH/MWh · dobowa średnia ważona',
  oree_kpi_zone_value: 'UA OES',
  oree_kpi_zone_note: 'Zjednoczony System Energetyczny — sieć główna',
  oree_hourly_empty: 'OREE jeszcze nie opublikowało danych dla tej daty. Wybierz wcześniejszą datę.',
  oree_hourly_widget_title: 'DAM — godzinowe ceny i wolumeny w dobie',
  oree_hourly_widget_subtitle: 'OREE day-ahead spot, godzinowo',
  oree_hourly_kpi_wavg: 'Dobowa cena ważona',
  oree_hourly_kpi_peak: 'Cena szczytowa',
  oree_hourly_kpi_low: 'Cena minimalna',
  oree_hourly_kpi_total_vol: 'Łączny wolumen',
  curtailment_banner_title: 'Aktywne ograniczenie generacji',
  curtailment_banner_cap_label: 'Ograniczenie do',
  curtailment_banner_pct_suffix: 'mocy znamionowej',
  curtailment_banner_since: 'od',
  curtailment_banner_source: 'Źródło',
  curtailment_banner_source_auto: 'wykryto automatycznie',
  curtailment_banner_source_sko: 'polecenie SKO',
  curtailment_banner_source_analyst: 'rekonstrukcja analityka',
  curtailment_banner_view_sko: 'Szczegóły SKO',
  nav_osr: 'OSR',
  osr_page_title: 'Polecenia OSR (Operatora Systemu Dystrybucji)',
  osr_page_subtitle: 'Polecenia ograniczenia generacji od lokalnego OSD — NIE są kompensowane. W odróżnieniu od SKO od Укренерго.',
  osr_log_new: 'Zarejestruj polecenie',
  osr_cancel: 'Anuluj',
  osr_save: 'Zapisz',
  osr_saving: 'Zapisywanie…',
  osr_close_event: 'Zamknij',
  osr_status_active: 'Aktywne',
  osr_info_title: 'Dlaczego oddzielnie od SKO:',
  osr_info_body: 'OSR to polecenie lokalnego operatora, zwykle przekazywane telefonicznie lub e-mailem. W przeciwieństwie do SKO od Укренерго, NIE jest kompensowane. Prognoza DAM jest automatycznie ograniczana do limitu OSR.',
  osr_log_form_title: 'Nowe polecenie OSR',
  osr_field_asset: 'Aktywo',
  osr_field_started: 'Początek',
  osr_field_pct: '% mocy znamionowej',
  osr_field_pmax_kw: 'Limit w kW',
  osr_field_dispatcher: 'Dyspozytor',
  osr_field_org: 'Organizacja',
  osr_field_reason: 'Powód',
  osr_field_notes: 'Notatki',
  osr_select_asset: 'wybierz SES',
  osr_section_active: 'Aktywne polecenia',
  osr_section_past: 'Historia',
  osr_empty_active: 'Brak aktywnych poleceń OSR.',
  osr_empty_past: 'Brak historii.',
  osr_col_asset: 'SES',
  osr_col_started: 'Początek',
  osr_col_ended: 'Koniec',
  osr_col_limit: 'Ograniczenie',
  osr_col_dispatcher: 'Dyspozytor',
  osr_col_reason: 'Powód',
  curtailment_banner_title_osr: 'Aktywne ograniczenie OSR (bez kompensacji)',
  curtailment_banner_title_sko: 'Aktywne polecenie SKO (kompensowane przez Укренерго)',
  curtailment_banner_source_dispatcher_phone: 'telefon dyspozytora',
  curtailment_banner_source_dispatcher_email: 'e-mail dyspozytora',
  curtailment_banner_view_osr: 'Szczegóły OSR',
  greeting_night: 'Dobranoc',
  d_demo_data: 'dane demo (API niedostępne)',
  d_disp_console: 'Pulpit dyspozytora',
  d_ses_plural: 'elektrownie',
  d_u_uah: 'UAH',
  d_u_mwh: 'MWh',
  d_u_mw: 'MW',
  d_u_gwh: 'GWh',
  d_u_wm2: 'W/m²',
  d_kpi_month_rev: 'Przychód od początku miesiąca',
  d_kpi_guaranteed: 'gwarantowane (prognoza × RDN)',
  d_kpi_contract_rdn: 'kontrakt RDN −3%',
  d_kpi_today_rev: 'Przychód dziś',
  d_kpi_sold_da: 'sprzedane dzień wcześniej wg prognozy',
  d_kpi_tech_status: 'Stan techniczny',
  d_kpi_generating: 'generuje',
  d_kpi_current_status: 'bieżący stan elektrowni',
  d_kpi_updates_auto: 'aktualizuje się automatycznie',
  d_kpi_forecast_today: 'Prognoza na dziś',
  d_kpi_expected_gen: 'oczekiwana produkcja dzienna',
  d_kpi_fact_now: 'fakt teraz',
  d_dkpi_cur_gen: 'Bieżąca generacja',
  d_dkpi_total_power_now: 'łączna moc teraz',
  d_dkpi_modbus_src: 'wg danych Modbus / SCADA',
  d_dkpi_model_weather: 'model v0.2.2 · prognoza pogody',
  d_dkpi_fulfilment: 'Realizacja prognozy',
  d_dkpi_fact_fc_avg: 'fakt / prognoza teraz (śr.)',
  d_dkpi_portfolio_eff: 'efektywność portfela',
  d_map_title: 'Mapa elektrowni',
  d_map_weather: 'Pogoda',
  d_map_no_telemetry: 'brak telemetrii',
  d_map_today_fact: 'Dziś (fakt)',
  d_map_forecast: 'Prognoza',
  d_map_revenue_guar: 'Przychód (gwar.)',
  d_map_insolation: 'Nasłonecznienie',
  d_map_cloud: 'zachmurzenia',
  d_btn_details: 'Szczegóły',
  d_rev_title: 'Przychód: plan vs fakt',
  d_rev_subtitle: 'szacowany (prognoza × RDN) vs faktyczny · przychód',
  d_p_today: 'Dziś',
  d_p_10d: '10 dni',
  d_p_month: 'Miesiąc',
  d_p_quarter: 'Kwartał',
  d_p_year: 'Rok',
  d_rev_estimated: 'Szacowany',
  d_rev_actual: 'Faktyczny',
  d_rev_losses: 'Straty',
  d_rev_plan_fulfil: 'Realizacja planu',
  d_chart_loading: 'Ładowanie…',
  d_chart_no_data: 'Brak danych za okres',
  d_plan: 'Plan',
  d_fact: 'Fakt',
  d_plan_forecast: 'Plan (prognoza)',
  d_gen_title: 'Generacja: plan vs fakt',
  d_gen_subtitle: 'prognoza vs faktyczna produkcja · MWh',
  d_gen_shortfall: 'Niedobór',
  d_gen_fulfil: 'Realizacja',
  d_port_title: 'Elektrownie portfela',
  d_port_fc_eff: 'ef. prognozy',
  d_port_rev_day: 'przychód/dzień',
  d_port_gen_today: 'wyprodukowano dziś',
  d_port_not_launched: 'Nie uruchomiono',
  d_port_fc_now: 'realizacja prognozy teraz',
  d_port_guar_rev_today: 'Gwar. przychód dziś',
  d_port_installed: 'zainstalowano',
  d_port_open: 'Otwórz stronę',
  d_ops_incidents: 'Incydenty',
  d_ops_active: 'aktywnych',
  d_ops_no_incidents: 'Brak aktywnych incydentów',
  d_ops_lost_value: 'Utracony przychód',
  d_ops_lost_sub: 'utracony przychód · szacunek dziś',
  d_ops_by_cause: 'Wg przyczyny',
  d_ops_no_losses: 'Brak strat',
  d_ops_uah_day: 'UAH / dzień',
  d_cause_outage: 'Wyłączenie',
  d_cause_curtail: 'Ograniczenie OSD',
  d_ops_resolved: 'usunięto',
  d_ops_since: 'od',
  d_ops_days: 'dni',
  d_inv_title: 'Stan falowników',
  d_inv_sub: 'szacunek wg mocy fakt. vs oczek. · aktualizacja w dzień',
  d_inv_working_portfolio: 'Działa (portfel)',
  d_inv_no_data: 'Brak danych',
  d_inv_st_pending: 'Oczekuje uruchomienia',
  d_inv_all: 'Wszystkie',
  d_inv_inv_working: 'falowników działa',
  d_inv_works: 'działa',
  d_inv_questionable: 'pod znakiem zapytania',
  d_inv_offline: 'offline',
  d_inv_night: 'Szacunek niedostępny w nocy',
  d_inv_no_tele: 'Brak telemetrii falowników',
  d_inv_abbr: 'fal.',
  d_inv_at: 'o',
  d_inv_footer: 'ℹ️ Brak telemetrii poszczegolnych falownikow na stacjach SMA (Nikopol, Nikelios) — stan szacowany z mocy lacznej. W nocy i bez slonca szacunek niedostepny (to norma, nie awaria).',
  d_sec_imbalance: 'Niebilans w miesiącu',
  d_sec_imbalance_sub: 'orientacyjnie · cena niebilansu wg aktów 14–15',
  d_sec_bess: 'Arbitraż BESS',
  d_sec_bess_sub: 'ładowanie w tanich godzinach / rozładowanie w drogich · dane w przygotowaniu',
  d_sec_settlements_with: 'Rozliczenia z',
  d_sec_offtaker: 'odbiorca',
  d_sec_receivables: 'Należności',
  d_sec_payment_due: 'płatność do',
  d_sec_reports: 'Raporty',
  d_bc_home: 'Główna',
  d_bc_dispatch: 'Dyspozytornia',
  d_bc_forecast: 'Prognoza',
  d_bc_analytics: 'Analityka',
  d_bc_market: 'Rynek',
  d_bc_info: 'Wiadomości',
  d_bc_assets: 'Aktywa',
};

export default translations;
